import React from 'react';
import UserForm from '../components/UserForm';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {User} from '../qql-shared/fragments';
import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';
import {ROLE_ADMIN} from '../constants/userConstants';

const UserQuery = gql`
  query user($_id: String!) {
    user(_id: $_id) {
      ...User
    }
  }
  ${User}
`;

const UserQueryConfig = {
  options: ({match, user: {_id}}) => ({variables: {_id}}),
};

const SaveUserProfileMutation = gql`
  mutation SaveUserProfileMutation(
    $_id: String
    $password: String
    $firstName: String!
    $lastName: String!
    $phone: String!
  ) {
    saveUserProfile(_id: $_id, password: $password, firstName: $firstName, lastName: $lastName, phone: $phone) {
      _id
      token
      firstName
      lastName
      email
    }
  }
`;

export const SaveUserProfileMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      user: {_id},
    },
  }) => ({
    save: user =>
      mutate({
        variables: {_id, ...user},
        updateQueries: {
          allUsers: (
            {allUsers, ...prev},
            {
              mutationResult: {
                data: {saveUser},
              },
            }
          ) => {
            saveUser.__typename = 'User';
            return {...prev, allUsers: allUsers.map(user => (user._id === _id ? saveUser : user))};
          },
        },
      }),
  }),
};

const MeForm = graphql(SaveUserProfileMutation, SaveUserProfileMutationConfig)(
  graphql(UserQuery, UserQueryConfig)(UserForm)
);

const AdminMeForm = graphql(SaveUserMutation, SaveUserMutationConfig)(graphql(UserQuery, UserQueryConfig)(UserForm));

const isAdmin = user => user && user.role === ROLE_ADMIN;

export default props => (isAdmin(props.user) ? <AdminMeForm {...props} /> : <MeForm {...props} />);



// WEBPACK FOOTER //
// ./src/containers/MeEdit.js